import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import { IGaDevice } from '../../../models/ga.model';
import { ApexOptions } from 'apexcharts';

interface IProps {
  data: IGaDevice;
}

const HomepageDeviceChart: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();
  const series: ApexOptions['series'] = [
    data.mobileCount || 0,
    data.tabletCount || 0,
    data.desktopCount || 0,
  ];

  const options: ApexOptions = {
    chart: { type: 'donut' },
    labels: [t('class.dashboard.column15'), t('class.dashboard.column16'), t('class.dashboard.column17')],
    legend: { position: 'bottom', fontFamily: 'Roboto' },
    dataLabels: {
      style: {
        colors: ['#ffffff'],
        fontFamily: 'Roboto'
      },
      background: {
        enabled: true,
        borderWidth: 0,
        opacity: 1,
        foreColor: '#000000',
        dropShadow: { enabled: false },
      },
      dropShadow: { enabled: false },
    },
    colors: ['#8bd0db', '#cde9ee', '#979fa8'],
    states: {
      hover: {
        filter: {
          type: 'none'
        }
      }
    },
    tooltip: {
      fillSeriesColor: false
    }
  };

  return <Chart series={series} options={options} type="donut" />;
};

export default HomepageDeviceChart;
